import React, { Component, useState, useEffect } from "react";
import { useGetGroupsQuery, useGetSystemsQuery, useGetFavoritesQuery, useAddFavoriteMutation, useRemoveFavoriteMutation } from '../../features/api/apiSlice'
import { setGroupFilter, setTalkgroupFilter, setCenterCall, setBackgroundAutoplay } from "../../features/callPlayer/callPlayerSlice";
import { useSelector, useDispatch } from 'react-redux'

import {
  Modal,
  Button,
  Icon,
  Dropdown,
  Grid,
  Form,
  List,
  Divider
} from "semantic-ui-react";
import "./FilterModal.css";

function GroupModal(props) {
  const shortName = useSelector((state) => state.callPlayer.shortName);
  const backgroundAutoplay = useSelector((state) => state.callPlayer.backgroundAutoplay);
  const centerCall = useSelector((state) => state.callPlayer.centerCall);
  const { data: groupData, isSuccess } = useGetGroupsQuery(props.shortName);
  const { data: allSystems } = useGetSystemsQuery();
  const { data: favorites } = useGetFavoritesQuery(props.shortName);
  const [addFavorite] = useAddFavoriteMutation();
  const [removeFavorite] = useRemoveFavoriteMutation();
  const [selectedGroup, setSelectedGroup] = useState(false);
  const [groupOptions, setGroupOptions] = useState([]);
  const [localCenterCall, setLocalCenterCall] = useState(centerCall);
  const [localBackgroundAutoplay, setLocalBackgroundAutoplay] = useState(backgroundAutoplay);
  const dispatch = useDispatch()
  const onClose = props.onClose;
  let system = false;


  if (allSystems) {
    system = allSystems.systems.find((system) => system.shortName === shortName)
  }

  const currentFavorite = favorites && favorites.find((favorite) => favorite.type === "group" && favorite.groupId === selectedGroup);

  function handleDone(onClose) {
    dispatch(setCenterCall(localCenterCall));
    dispatch(setBackgroundAutoplay(localBackgroundAutoplay));
    if (selectedGroup && (selectedGroup!="all")) {
      dispatch(setGroupFilter(selectedGroup))

      //dispatch({type: types.SET_GROUP_FILTER, groupId: selectedGroup  })
      onClose(true);
    } else {
      onClose(false);
    }
  }

  function handleFavoriteClick(favorite) {
    if (favorite.type === "group") {
      dispatch(setGroupFilter(favorite.groupId));
    } else {
      dispatch(setTalkgroupFilter(favorite.talkgroups));
    }
    onClose(true);
  }

  function toggleGroupFavorite() {
    if (currentFavorite) {
      removeFavorite({ shortName: props.shortName, id: currentFavorite._id });
    } else {
      const group = groupOptions.find((option) => option.value === selectedGroup);
      addFavorite({
        shortName: props.shortName,
        body: { type: "group", groupId: selectedGroup, label: group ? group.text : "" }
      });
    }
  }


  useEffect(() => {
    if (isSuccess) {
      let temp = [{
        key: "all",
        value: "all",
        text: "All Calls"
      }];
      for (const num in groupData) {
        const group = groupData[num];
        const obj = {
          key: group._id,
          value: group._id,
          text: group.groupName
        }
        temp.push(obj);
      }
      setGroupOptions(temp);
    }
  }, [groupData]);





  return (

    <Modal open={props.open} onClose={onClose} size='tiny'>

      <Modal.Header>{system && system.name}</Modal.Header>
      <Modal.Content >
        <Modal.Description>
          <Grid >
            <Grid.Row>
              <Grid.Column width={8}>
                {system && system.description}
                {favorites && favorites.length > 0 && (
                  <>
                    <Divider />
                    <p>Your Favourites</p>
                    <List selection verticalAlign='middle'>
                      {favorites.map((favorite) => (
                        <List.Item key={favorite._id} onClick={() => handleFavoriteClick(favorite)}>
                          <Icon name='star' color='yellow' />
                          <List.Content>{favorite.label}</List.Content>
                        </List.Item>
                      ))}
                    </List>
                  </>
                )}
              </Grid.Column>
              <Grid.Column width={8}>
                <p>Choose the type of calls you want to listen to</p>
                <Form>
                <Form.Group>
                  <Form.Select width={13} placeholder='All Calls' fluid selection options={groupOptions} name='selectedGroup' onChange={(e, data) => setSelectedGroup(data.value)} />
                  <Form.Field width={3}>
                    <Button
                      icon
                      basic={!currentFavorite}
                      color={currentFavorite ? 'yellow' : undefined}
                      disabled={!selectedGroup || selectedGroup === "all"}
                      onClick={toggleGroupFavorite}
                      title={currentFavorite ? "Remove favourite" : "Add favourite"}
                    >
                      <Icon name='star' />
                    </Button>
                  </Form.Field>
                </Form.Group>
                <Form.Checkbox label='Focus on call playing' checked={localCenterCall} onChange={(e, data) => setLocalCenterCall(data.checked)} />
                <Form.Checkbox label='Background autoplay' checked={localBackgroundAutoplay} onChange={(e, data) => setLocalBackgroundAutoplay(data.checked)} />
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>

        </Modal.Description>

      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => handleDone(onClose)} >
          <Icon name='headphones' /> Listen
        </Button>
      </Modal.Actions>
    </Modal>

  )
}

export default GroupModal;
